import { ButtonSlim, Modal } from '@Calix-Commerce/design-system';
import { useState } from 'react';

const EMPTY_ACCESS_MESSAGE =
  'You have not been granted access to the My Calix Store. Use the button below to request access from your Customer Operations Representative.';

const PARTIAL_ACCESS_MESSAGE =
  'You have not been granted access to this portion of the My Calix Store. Use the button below to request access from your Customer Operations Representative.';

export const NoAccessModalContent = ({
  onSendRequestMessage,
  emptyAccess = false,
}: {
  onSendRequestMessage: () => Promise<void>;
  emptyAccess?: boolean;
}) => {
  const [messageSent, setMessageSent] = useState(false);

  if (messageSent) {
    return <p>Thank you! Your request has been sent to your Customer Operations Representative.</p>;
  }

  return (
    <div>
      <p>{emptyAccess ? EMPTY_ACCESS_MESSAGE : PARTIAL_ACCESS_MESSAGE}</p>
      <ButtonSlim
        onClick={() => {
          onSendRequestMessage().then(() => {
            setMessageSent(true);
          });
        }}
      >
        Request Access
      </ButtonSlim>
    </div>
  );
};

export const NoAccessModal = ({
  handleSendRequestMessage,
  emptyAccess = false,
}: {
  handleSendRequestMessage: () => Promise<void>;
  emptyAccess?: boolean;
}) => {
  return (
    <Modal
      isOpen
      position="top"
      title="Insufficient Privileges"
      //@ts-expect-error Design-System Modal component typing accepts strings as content but JSX.Element
      content={
        <NoAccessModalContent
          onSendRequestMessage={handleSendRequestMessage}
          emptyAccess={emptyAccess}
        />
      }
      confirmButtonText="Close"
      onConfirmation={() => window.location.replace(import.meta.env.VITE_CALIX_PORTAL_URL)}
    />
  );
};
